import { isMobilePhoneNumber, EMAIL_REGEX } from '@medflex/shared-utils';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import hasUmlauts from '@medflex/utils/hasUmlauts';

const useSessionsNewAnonymousParticipantSchema = referenceType => {
  const { t } = useTranslation('components');
  const schema = yup.object().shape({
    firstName: yup.string().trim().required(t('global:validation.messages.required')),
    lastName: yup.string().trim().required(t('global:validation.messages.required')),
    ...(referenceType === 'email' && {
      email: yup
        .string()
        .trim()
        .required(t('global:validation.messages.required'))
        .test('', t('global:validation.messages.emailUmlauts'), value => !hasUmlauts(value))
        .matches(EMAIL_REGEX, t('global:validation.messages.email')),
    }),
    ...(referenceType === 'phone' && {
      phone: yup
        .string()
        .trim()
        .required(t('global:validation.messages.required'))
        .test('', t('global:validation.messages.mobileNumber'), value =>
          isMobilePhoneNumber(value),
        ),
    }),
  });

  return schema;
};

export default useSessionsNewAnonymousParticipantSchema;
